import { NgModule } from '@angular/core';
import { breadcrumbsIntegration, browserTracingIntegration, consoleLoggingIntegration, httpClientIntegration, replayCanvasIntegration, replayIntegration, TraceService } from '@sentry/angular';
import type { Integration } from '@sentry/core';
import 'moment/locale/fr';
import { environment } from '../environments/environment';

export const isBannedError = (error: string | Error | unknown): boolean => {
  const errorsToIgnore = ['INTERNAL ASSERTION FAILED', 'network-request-failed'];
  let errorMessage: string;
  if (!error) {
    return false;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'object' && 'message' in error) {
    errorMessage = (error as Error).message;
  } else {
    return false;
  }

  for (const errorToIgnore of errorsToIgnore) {
    if (errorMessage && errorMessage.includes(errorToIgnore)) {
      return true;
    }
  }
  return false;
};

export function prepareIntegrations(isProd: boolean): Integration[] {
  const integrations: Integration[] = [browserTracingIntegration(), breadcrumbsIntegration({ console: false }), consoleLoggingIntegration({ levels: ['warn', 'error'] })];
  integrations.push(replayIntegration({ maskAllText: false }));
  if (environment.target !== 'app') {
    integrations.push(replayCanvasIntegration());
  }
  integrations.push(httpClientIntegration({ failedRequestStatusCodes: [[400, 599]] }));
  return integrations;
}

@NgModule(/* TODO(standalone-migration): clean up removed NgModule class manually.
{
  declarations: [AppComponent],
  imports: [
    AppFirebaseModule,
    BrowserModule,
    HammerModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: createTranslateLoader, deps: [HttpClient] },
      useDefaultLang: true,
      defaultLanguage: 'en',
    }),
    AppRoutingModule,
    ApiModule.forRoot(),
    CommonApiModule.forRoot(),
    SecurityModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.target !== 'app' && environment.name !== 'local' }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
    RouterInterceptorService,
  ],
  bootstrap: [AppComponent],
} */)
export class AppModule {
  constructor(trace: TraceService) {
    // Start sentry trace service
  }
}
